import { render } from "./KingdomProfile.vue?vue&type=template&id=eb328cfc"
import script from "./KingdomProfile.vue?vue&type=script&lang=js"
export * from "./KingdomProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/KingdomProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb328cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb328cfc', __exports__)) {
    api.reload('eb328cfc', __exports__)
  }
  
  module.hot.accept("./KingdomProfile.vue?vue&type=template&id=eb328cfc", () => {
    api.rerender('eb328cfc', render)
  })

}


export default __exports__